import React, { createContext, useContext } from "react";
import { PresentationWithId } from "../interfaces/IPresentations";

// Interfejs dla wyniku operacji
interface OperationResult {
  success: boolean;
  error?: string;
  presentation?: PresentationWithId;
}

interface PresentationsContextType {
  // Stan
  presentations: PresentationWithId[];
  isLoading: boolean;

  // Orkiestrowane metody (z hooka)
  handlePresentationAdd: (presentationData: PresentationWithId) => Promise<OperationResult>;
  handlePresentationUpdate: (
    presentationId: string,
    updatedData: Partial<PresentationWithId>
  ) => Promise<OperationResult>;
  handlePresentationDelete: (presentationId: string) => Promise<OperationResult>;
  handleSoloPresentationsBatch: (
    presentationsToAdd: PresentationWithId[],
    presentationsToDelete: PresentationWithId[]
  ) => Promise<OperationResult>;
}

const PresentationsContext = createContext<PresentationsContextType | undefined>(undefined);

export default function PresentationsProvider({
  children,
  presentations,
  isLoading,
  handlePresentationAdd,
  handlePresentationUpdate,
  handlePresentationDelete,
  handleSoloPresentationsBatch,
}: {
  children: React.ReactNode;
  presentations: PresentationWithId[];
  isLoading: boolean;
  handlePresentationAdd: (presentationData: PresentationWithId) => Promise<OperationResult>;
  handlePresentationUpdate: (
    presentationId: string,
    updatedData: Partial<PresentationWithId>
  ) => Promise<OperationResult>;
  handlePresentationDelete: (presentationId: string) => Promise<OperationResult>;
  handleSoloPresentationsBatch: (
    presentationsToAdd: PresentationWithId[],
    presentationsToDelete: PresentationWithId[]
  ) => Promise<OperationResult>;
}) {
  return (
    <PresentationsContext.Provider
      value={{
        presentations,
        isLoading,
        handlePresentationAdd,
        handlePresentationUpdate,
        handlePresentationDelete,
        handleSoloPresentationsBatch,
      }}
    >
      {children}
    </PresentationsContext.Provider>
  );
}

export const usePresentationsContext = (): PresentationsContextType => {
  const context = useContext(PresentationsContext);
  if (context === undefined) {
    throw new Error(
      "Błąd w PresentationsContext: usePresentationsContext must be used within a PresentationsProvider"
    );
  }
  return context;
};
